import Guyn from 'guyn/guyn/json/guyn.json'
import Modal from '@/components/modal.vue'
import Shape from '@/components/shape.vue'
import GameMenu from '@/components/menu.vue'
import Button from '@/components/button.vue'
import kickSound from '@/assets/audio/kick.mp3'
import { grid, shapes, points, blocks, colors } from './data.js'
import { Numbers, Color } from '@tggr/vue-mixins'
import { Howl } from 'howler'

export default {
	components: {
		Modal,
		Shape,
		GameMenu,
		Button,
	},
	mixins: [Numbers, Color],
	data: () => ({
		debug: false,
		ctx: null,
		canvas: null,
		initialized: false,
		touchDevice: true,
		animFrame: null,
		autoplay: false,
		timeout: null,
		update: {
			points: false,
			reducePoints: false,
		},
		cursor: { current: { x: 0, y: 0 }, start: { x: 0, y: 0 } },
		can: {
			move: false,
			rotate: true,
		},
		block: {
			size: 1,
			margin: 1,
			width: 9,
			height: 9,
			grid: [],
			type: 'block',
			gridWidth: 0,
			gridHeight: 0,
			startOfLine: [],
			endOfLine: [],
			background: [],
		},
		startPoints: {
			easy: [
				0,
				10,
				20,
				30,
				50,
				60,
				70,
				80,
				8,
				16,
				24,
				32,
				48,
				56,
				64,
				72,
			],

			hard: [],
		},
		used: {
			rotates: 0,
			skips: 0,
			steps: 0,
		},
		current: {
			sessionId: null,
			changers: 0,
			rotates: 0,
			points: 0,
			deletes: 0,
			actives: [0],
			shape: { x: 0, y: 0 },
			matches: 0,
			hovering: [],
		},
	}),
	computed: {
		shapes() {
			return shapes
		},
		points() {
			return points
		},
		blockGroups() {
			return blocks
		},
		blockGrid() {
			return grid
		},
		colorScheme() {
			if (this.Settings.colorMode) return colors[this.Settings.colorMode]
			else return colors.darkMode
		},
		menuActive: {
			get() {
				return this.$store.state.ui.menu.active
			},
			set(bool) {
				this.$store.dispatch('ui/setMenuActive', bool)
			},
		},
		restart() {
			return this.$store.state.ui.restart
		},
		Settings() {
			return this.$store.state.ui.settings
		},
		available() {
			return this.blockGrid.filter(item => {
				return !this.current.actives.includes(item)
			})
		},
	},
	watch: {
		restart: function() {
			if (this.restart) {
				this.restartGame()
			}
		},
		'current.points': function(points, oldPoints) {
			if (!this.initialized) return
			if (points > oldPoints + 100) {
				this.$store.dispatch('modal/setModal', {
					type: 'big-points',
					timeout: 2000,
					content: `<h3>${points - oldPoints}</h3><h4>+1 skip</h4>`,
				})
			} else if (points > oldPoints + 89) {
				this.update.points = true
				this.timeout = setTimeout(() => {
					this.update.points = false
				}, 1000)
				this.$store.dispatch('modal/setModal', {
					type: 'points',
					timeout: 1000,
					content: `<h3>+${points -
						oldPoints}</h3><h4>+1 rotate</h4>`,
					settings: {
						showBackground: false,
					},
				})
			} else if (points > oldPoints) {
				this.update.points = true
				this.timeout = setTimeout(() => {
					this.update.points = false
				}, 1000)
				this.$store.dispatch('modal/setModal', {
					type: 'points',
					timeout: 1000,
					content: `<h3>+${points - oldPoints}</h3>`,
					settings: {
						showBackground: false,
					},
				})
			} else {
				this.update.reducePoints = true
				this.timeout = setTimeout(() => {
					this.update.reducePoints = false
				}, 1000)
				this.$store.dispatch('modal/setModal', {
					type: 'points',
					timeout: 1000,
					content: `<h3>${points - oldPoints}</h3>`,
					settings: {
						showBackground: false,
					},
				})
			}
			this.$store.dispatch('scores/setScore', {
				session: this.current.sessionId,
				score: points,
				used: this.used,
			})
		},
	},
	mounted() {
		const game = document.querySelector('#game')
		game.addEventListener('touchmove', e => {
			this.handleTouchMove(e)
		})
		game.addEventListener('touchend', e => {
			this.handleTouchUp(e)
		})
		game.addEventListener('mousemove', e => {
			this.handleTouchMove(e)
		})
		game.addEventListener('mouseup', e => {
			this.handleTouchUp(e)
		})

		this.init()
		this.intro()
		window.addEventListener('resize', () => {
			this.setSizes()
			this.buildGrid()
		})
	},
	created() {
		this.setBorderBlocks()
	},
	methods: {
		toggleMenu() {
			this.$store.dispatch('ui/toggleMenuActive')
		},
		playSound(sound) {
			if (!this.Settings.audio) return
			// Setup the new Howl.
			const sounds = {
				kick: new Howl({
					src: [kickSound],
				}),
			}

			switch (sound) {
				case 'kick':
					sounds.kick.play()
					break
			}
		},
		intro() {
			this.autoplay = true
			this.loop()
			for (let p = 0; p < this.points.length; p++) {
				this.timeout = setTimeout(() => {
					this.clearBoard()
					this.current.actives = this.points[p].data
					if (p == this.points.length - 1) {
						this.timeout = setTimeout(() => {
							this.clearBoard()
							this.current.actives = new Array()
							this.current.actives = [...this.startPoints['easy']]
							this.initialized = true
							this.autoplay = false
						}, 100)
					}
				}, p * 100)
			}
		},
		init() {
			this.touchDevice = this.isTouchDevice()

			this.canvas = document.getElementById('game')
			this.ctx = this.canvas.getContext('2d')
			this.current.sessionId = new Date().getTime()

			// Set defaults:
			if (this.ctx) {
				this.setSizes()
				this.buildGrid()
				this.buildBackground()
				this.setShape()
				this.loop()
			}
			this.current.changers = 0
			this.current.rotates = 0
			this.current.points = 0
			this.current.actives = []
			this.used.rotates = 0
			this.used.skips = 0
			this.used.steps = 0

			this.$store.dispatch('ui/setRestart', false)
		},
		setBorderBlocks() {
			// let total = this.block.width * this.block.height;
			// let endOfLine = [];
			// let startOfLine = [];
			// for (let i = 0; i < total; i) {
			// 	endOfLine.push(i);
			// 	startOfLine.push(i - 1);
			// }
			// console.log(endOfLine, startOfLine);
			this.block.endOfLine = [8, 17]
			this.block.startOfLine = [0, 9]
		},
		isTouchDevice() {
			return (
				'ontouchstart' in window ||
				navigator.MaxTouchPoints > 0 ||
				navigator.msMaxTouchPoints > 0
			)
		},
		clearBoard() {
			for (let i = 0; i < this.block.grid.length; i++) {
				this.block.grid[i].stage = 0
			}
		},

		deleteShape() {},
		rotateShape() {
			if (this.current.rotates < 1) return
			// console.log(this.current.shape);
			const siblings = this.shapes.filter(shape => {
				return shape.title == this.current.shape.title
			})

			for (let s = 0; s < siblings.length; s++) {
				// console.log(siblings[s].rotation, this.current.shape.rotation, s);
				if (siblings[s].rotation == this.current.shape.rotation) {
					let newIdx = s < siblings.length - 1 ? s + 1 : 0
					this.setShape(this.shapes.indexOf(siblings[newIdx]))
					this.current.rotates = this.current.rotates - 1

					return
				}
			}
			this.current.rotates = this.current.rotates + 1
			this.checkShapeFit()
		},

		setCursor(e, mode) {
			let x = e.clientX
			let y = e.clientY
			if (this.touchDevice) {
				x = e['targetTouches'][0]['clientX']
				y = e['targetTouches'][0]['clientY']
			}
			switch (mode) {
				case 'move':
				case 'start':
					this.cursor.current.x = x
					this.cursor.current.y = y
					break
				case 'end':
					this.cursor.current.x = 0
					this.cursor.current.y = 0
					break
			}
		},

		handleTouchMove(e) {
			if (this.initialized) this.setCursor(e, 'move')
			this.animFrame = window.requestAnimationFrame(this.loop)
		},
		handleTouchUp(e) {
			if (!this.initialized) return
			if (this.can.drop) {
				this.dropShape()
				this.setShape()
				window.navigator.vibrate(20)
				this.playSound('kick')
				this.loop()
			}
			this.timeout = setTimeout(() => {
				this.current.hovering = []
				this.setCursor(e, 'end')
				this.loop()
			}, 200)
		},

		grid(size) {
			return (Math.min(window.innerWidth, window.innerHeight) / 24) * size
		},
		upCurrentPoints(final) {
			setTimeout(() => {
				this.current.points =
					this.current.points +
					Math.ceil((final - this.current.points) / 10)
				if (this.current.points < final) {
					this.upCurrentPoints(final)
				}
			}, 50)
		},
		dropShape() {
			if (!this.can.drop) return

			for (let i = 0; i < this.current.hovering.length; i++) {
				this.current.actives.push(this.current.hovering[i])
			}
			this.current.actives.sort()

			this.upCurrentPoints(
				this.current.points + this.current.hovering.length
			)

			this.can.drop = false
			this.used.steps = this.used.steps + 1
			this.current.hovering = []
		},
		setSizes() {
			this.canvas.width = window.innerWidth
			this.canvas.height = window.innerHeight

			this.block.size = this.grid(2)
			this.block.margin = this.grid(0.4)

			let bh = this.block.height
			let bw = this.block.width
			let bm = this.block.margin
			let bs = this.block.size

			this.block.gridWidth = (bs + bm) * bw - bm
			this.block.gridHeight = (bs + bm) * bh - bm
		},
		buildGrid() {
			let grid = []
			let bm = this.block.margin
			let bs = this.block.size
			let marginLeft = this.canvas.width / 2 - this.block.gridWidth / 2
			let marginTop = this.canvas.height / 2 - this.block.gridHeight / 2

			for (let y = 0; y < this.block.height; y++) {
				for (let x = 0; x < this.block.width; x++) {
					grid.push({
						x: x * (bs + bm) + marginLeft,
						y: y * (bs + bm) + marginTop,
						stage: 0,
					})
				}
			}
			this.block.grid = grid
		},
		checkPoints() {
			let points = 0
			let pointSets = []
			let toRemove = []
			let bonusBricks = []

			// You can win!
			if (this.current.actives.length == 0 && this.used.steps > 0) {
				// alert('YOU WON!');
			}

			// For each possible point combination.
			this.points.forEach(option => {
				let win = true
				for (let p = 0; p < option.data.length; p++) {
					if (!this.current.actives.includes(option.data[p])) {
						win = false
						break
					}
				}

				// If this current Set is a win, take away all stones.
				if (win) {
					pointSets.push(option.title)
					for (let p = 0; p < option.data.length; p++) {
						toRemove.push(option.data[p])
						points++
					}
				}
			})

			// Check if there is a combo:

			// Combo forwardslash + backslash

			if (
				pointSets.includes('forwardslash') &&
				pointSets.includes('backslash')
			) {
				toRemove.forEach(block => {
					bonusBricks.push(this.blocksAround(block))
					// console.log(this.blocksAround(block));
				})
			}
			// if (toRemove.length > 0) console.log(toRemove);
			this.removeBlocks(toRemove)

			// if (bonusBricks.length) console.log(bonusBricks);
			// console.log(bonusBricks);
			// setTimeout(() => {
			// 	this.removeBlocks(bonusBricks);
			// }, 200);

			let addPoints = points * 10

			// Set bonusses:
			if (addPoints > 100) {
				this.current.changers = this.current.changers + 1
			}
			if (addPoints >= 90) {
				this.current.rotates = this.current.rotates + 1
			}

			if (addPoints)
				this.upCurrentPoints(
					this.current.points + addPoints * (points / 9)
				)
		},
		removeBlocks(blocks) {
			for (let i = 0; i < blocks.length; i++) {
				this.block.grid[i].stage = 1
			}
			// this.pauseLoop(1000);
			for (let i = 0; i < blocks.length; i++) {
				this.current.actives.splice(
					this.current.actives.indexOf(blocks[i]),
					1
				)
			}
		},

		inGrid(number) {
			let grid = new Array(this.block.width * this.block.height)
			return grid.includes(number)
		},

		blocksAround(block) {
			let start = this.block.startOfLine
			let end = this.block.endOfLine
			// console.log(start, end);
			let bricks = []
			// All next blocks
			let next = block + 1
			if (!end.includes(next) && this.inGrid(next)) bricks.push(next)

			// All prev blocks
			let prev = block - 1
			if (!start.includes(prev) && this.inGrid(prev)) bricks.push(prev)

			// All above
			let above = block - this.block.width
			if (this.inGrid(above)) bricks.push(above)

			// All above right
			let aboveRight = block - (this.block.width - 1)
			if (!start.includes(aboveRight) && this.inGrid(aboveRight))
				bricks.push(aboveRight)

			// All above left
			let aboveLeft = block - (this.block.width + 1)
			if (!end.includes(aboveLeft) && this.inGrid(aboveLeft))
				bricks.push(aboveLeft)

			// All under
			let under = block + this.block.width
			if (this.inGrid(under)) bricks.push(under)

			// All right under
			let underRight = block + (this.block.width + 1)
			if (!start.includes(underRight) && this.inGrid(underRight))
				bricks.push(block + this.block.width + 1)

			// All left under
			let underLeft = block + (this.block.width - 1)
			if (!end.includes(underLeft) && this.inGrid(underLeft))
				bricks.push(underLeft)

			return bricks
		},

		buildBackground() {
			let background = []
			for (let x = 0; x < this.block.width / 3; x++) {
				for (let y = 0; y < this.block.height / 3; y++) {
					let marginLeft =
						this.canvas.width / 2 - this.block.gridWidth / 2
					let marginTop =
						this.canvas.height / 2 - this.block.gridHeight / 2
					let xx =
						(this.block.size + this.block.margin) * 3 * x +
						marginLeft
					let yy =
						(this.block.size + this.block.margin) * 3 * y +
						marginTop
					let size =
						(this.block.size + this.block.margin) * 3 -
						this.block.margin

					background.push({
						x: xx,
						y: yy,
						size: size,
						height: size,
						even: this.isOdd(x + y),
					})
				}
			}
			this.block.background = background
		},
		updateGrid() {
			// The Background
			for (let x = 0; x < this.block.background; x++) {
				let block = this.block.background[x]

				if (block.even) {
					this.ctx.fillStyle = Guyn.White
				} else {
					this.ctx.fillStyle = Guyn.Nightblue
				}
				// this.ctx.stroke = 3;
				this.ctx.beginPath()
				this.ctx.arc(
					block.x + block.size / 2,
					block.y + block.size / 2,
					block.size / 2,
					0,
					2 * Math.PI
				)
				this.ctx.fill()
			}

			for (let i = 0; i < this.block.grid.length; i++) {
				let xx = this.block.grid[i].x
				let yy = this.block.grid[i].y

				let size = this.block.size

				if (this.current.actives.includes(i))
					this.block.grid[i].stage = 2

				let UnevenBlocks = [].concat.apply(
					[],
					[
						this.blockGroups[0],
						this.blockGroups[2],
						this.blockGroups[4],
						this.blockGroups[6],
						this.blockGroups[8],
					]
				)
				// console.log(UnevenBlocks.length);

				switch (this.block.grid[i].stage) {
					case 0:
						this.ctx.fillStyle = this.colorScheme.normal

						if (UnevenBlocks.includes(i))
							this.ctx.fillStyle = this.colorScheme.gridEven
						else this.ctx.fillStyle = this.colorScheme.gridUneven

						this.ctx.shadowColor = `rgba(0,0,0,0)`
						this.ctx.shadowOffsetY = 0
						break
					case 1:
						if (this.can.drop) {
							yy = yy - 4
							this.ctx.fillStyle = this.colorScheme.candrop
							this.ctx.shadowColor = this.colorScheme.candropShadow
							this.ctx.shadowOffsetY = 4
						} else {
							this.ctx.fillStyle = this.colorScheme.cantdrop
							this.ctx.shadowColor = this.colorScheme.candropShadow
							this.ctx.shadowOffsetY = 0
							// this.ctx.shadowColor = this.colorScheme.cantdropShadow;
						}
						break
					case 2:
						yy = yy - 4
						this.ctx.fillStyle = this.colorScheme.active
						this.ctx.shadowColor = this.colorScheme.activeShadow
						this.ctx.shadowOffsetY = 4
						break
					case 3:
						yy = yy - 4
						this.ctx.fillStyle = this.colorScheme.activeHover
						this.ctx.shadowColor = this.colorScheme.activeHoverShadow
						this.ctx.shadowOffsetY = 4
						break
					case 4:
						yy = yy - 4
						this.ctx.fillStyle = this.colorScheme.candrop
						this.ctx.shadowColor = `rgba(0,0,0,0)`
						this.ctx.shadowOffsetY = 4
						break
				}
				this.ctx.beginPath()

				// this.ctx.rect(xx, yy, size, size);
				this.ctx = this.roundRect(this.ctx, xx, yy, size, size)
				this.ctx.fill()
			}
		},
		changeShape() {
			if (this.current.changers < 1) return
			this.current.points = Math.floor(
				this.current.points - this.current.points / 10
			)
			this.current.changers = this.current.changers - 1
			this.used.skips = this.used.skips + 1
			this.setShape()
		},
		setShape(idx = null) {
			if (idx) {
				this.current.shape = this.shapes[idx]
				this.current.shape.x = 100
				this.current.shape.y = 100
			} else {
				if (this.current.nextShape) {
					this.current.shape = this.current.nextShape
				} else {
					this.current.shape = this.shapes[
						Math.floor(Math.random() * this.shapes.length)
					]
					this.current.shape.x = 100
					this.current.shape.y = 100
				}

				this.current.nextShape = this.shapes[
					Math.floor(Math.random() * this.shapes.length)
				]
				this.current.nextShape.x = 0
				this.current.nextShape.y = 0

				if (this.current.shape.rotation !== false)
					this.can.rotate = true
				else this.can.rotate = false
			}
			this.createShape()

			if (this.initialized) {
				setTimeout(() => {
					this.checkShapeFit()
				}, 750)
			}
			return
		},
		gameOver() {
			let grid = []
			for (let i = 0; i < 9 * 9; i++) {
				grid.push(i)
			}
			// Create a list with available blocks in the grid.
			const available = grid.filter(item => {
				return !this.current.actives.includes(item)
			})

			this.initialized = false
			this.autoplay = true
			for (let b = 0; b < available.length; b++) {
				setTimeout(() => {
					this.block.grid[available[b]].stage = 1
				}, b * 100)
			}
			setTimeout(() => {
				for (let g = 0; g < this.block.grid.length; g++) {
					setTimeout(() => {
						this.block.grid[g].stage = 1
					}, g * 100)
				}
			}, available.length * 100 + 100)
		},
		checkShapeFit() {
			// Create an arry with all the numbers for the grid
			const gridRows = this.blockGroups
			const available = this.available
			const shapeData = this.current.shape.data // Just to make it a little shorter

			// Create an array with all the numbers, but divided by rows.

			// if (this.debug) console.log(gridRows)

			// Has a fit will be default false and set to true when possible.
			let fits = []

			// Go through all available blocks
			for (let a = 0; a < available.length; a++) {
				let ids = []
				// let rows = 0;
				let pass

				// For every block, create an array with the positions of the current element.
				for (let r = 0; r < shapeData.length; r++) {
					let row = 0
					pass = true
					for (let c = 0; c < shapeData[r].length; c++) {
						if (this.current.shape.data[r][c] > 0) {
							// Set the blocks for this current shape.
							let checkBlock = available[a] + r * 9 + c

							// But wait... sometimes... elements which should be on the same row, could be breaking
							// to the next row. That won't fit the element.
							for (let gr = 0; gr < gridRows.length; gr++) {
								if (gridRows[gr].includes(checkBlock + 1)) {
									row = gr
									if (c > 0) {
										if (row !== gr) {
											pass = false
										}
									} else {
										row = gr
									}
								}
							}
							// So.. if it passes. That means, it doesnt go to the next row. We push the
							// option into the pile.
							if (pass) ids.push(checkBlock)
						}
					}
				}
				let fitShape = true

				// Go check every option with the available lots. If there is only one part that won't fit. It won't pass.
				for (let s = 0; s < ids.length; s++) {
					if (!available.includes(ids[s])) {
						fitShape = false
					}
				}
				// So now we know, if there  is a fit. So we can safely say there is an element which will fit.
				if (fitShape) fits.push(ids)
			}

			// if (this.debug)
			// 	console.log(fits, fits.length, available, this.current.actives)
			// console.log(hasFit);
			// If there is no fit....
			if (fits.length < 1) {
				// if (this.debug) console.log(this.current)
				if (this.current.rotates < 1 && this.current.changers < 1) {
					this.gameOver()
					setTimeout(() => {
						this.$store.dispatch('modal/setModal', {
							type: 'gameover',
							active: true,
							content: `<h3>Game Over</h3><h4>${this.current.points} in ${this.used.steps}</h4>`,
							button: {
								text: 'New game',
								function: () => {
									this.$store.dispatch('ui/restart')
								},
							},
						})
					}, 1000)
				} else if (
					this.current.rotates > 0 &&
					this.current.changers > 0
				) {
					setTimeout(() => {
						this.$store.dispatch('modal/setModal', {
							type: 'wontfit',

							timeout: 3000,
							content: `<h3>Yeahhh.. that won't fit..</h3><h4>But you can still rotate or skip.</h4>`,
						})
					}, 1000)
				} else if (
					this.current.rotates > 0 &&
					this.current.changers < 1
				) {
					setTimeout(() => {
						this.$store.dispatch('modal/setModal', {
							type: 'wontfit',
							timeout: 3000,
							content: `<h3>Yeahhh.. that won't fit..</h3><h4>You can try to rotate?</h4>`,
						})
					}, 1000)
				} else if (
					this.current.rotates < 1 &&
					this.current.changers > 0
				) {
					setTimeout(() => {
						this.$store.dispatch('modal/setModal', {
							type: 'wontfit',
							timeout: 3000,
							content: `<h3>Yeahhh.. that won't fit..</h3><h4>You can try to skip this one..</h4>`,
						})
					}, 1000)
				}
			}
		},
		createShape() {
			let grid = []
			let bm = this.block.margin
			let bs = this.block.size
			for (let y = 0; y < this.current.shape.data.length; y++) {
				for (let x = 0; x < this.current.shape.data[y].length; x++) {
					if (this.current.shape.data[y][x] > 0) {
						let sx = x * (bs + bm)
						let sy = y * (bs + bm)
						let shapeW =
							(bs + bm) * this.current.shape.data[y].length - bm
						let shapeH =
							(bs + bm) * this.current.shape.data.length - bm
						if (!this.touchDevice) shapeH = shapeH / 2
						else shapeH = shapeH + 100
						grid.push({
							x: sx + this.cursor.current.x - shapeW,
							y: sy + this.cursor.current.y - shapeH,
							stage: 0,
						})
					}
				}
			}
			this.shape = grid
		},

		shapeUpdate() {
			this.createShape()
			for (let i = 0; i < this.shape.length; i++) {
				let xx = this.shape[i].x
				let yy = this.shape[i].y

				let size = this.block.size / 4

				switch (this.shape[i].stage) {
					case 0:
						this.ctx.fillStyle = this.colorScheme.shapeHover
						break
					case 1:
						this.ctx.fillStyle = 'orange'
						break
					case 2:
						this.ctx.fillStyle = 'green'
						break
					case 3:
						this.ctx.fillStyle = 'blue'
						break
				}
				this.ctx.beginPath()
				this.ctx.shadowColor = `rgba(0,0,0,0)`
				this.ctx.shadowOffsetY = 0

				this.ctx.arc(xx + size * 2, yy + size * 2, size, 0, 2 * Math.PI)

				this.ctx.fill()
			}
		},
		checkShapePosition() {
			let matches = 0
			let xdif
			let ydif
			let hovering = []
			if (!this.shape) return
			for (let s = 0; s < this.shape.length; s++) {
				for (let g = 0; g < this.block.grid.length; g++) {
					xdif = this.shape[s].x - this.block.grid[g].x
					ydif = this.shape[s].y - this.block.grid[g].y
					if (xdif < 0) xdif = xdif * -1
					if (ydif < 0) ydif = ydif * -1

					if (
						ydif < this.block.size / 2 &&
						xdif < this.block.size / 2
					) {
						hovering.push(g)
					}
					this.shape[s].stage = this.block.grid[g].stage
				}
				// Set Hovering stages
			}

			for (let g = 0; g < this.block.grid.length; g++) {
				if (hovering.includes(g)) {
					if (this.current.actives.includes(g)) {
						// Set to Checked + hover;
						this.block.grid[g].stage = 3
					} else {
						// Set to Normal + hover;
						matches++
						this.block.grid[g].stage = 1
					}
				} else {
					if (this.current.actives.includes(g)) {
						// Set to CHeck;
						this.block.grid[g].stage = 2
					} else {
						// Set to Normal;
						this.block.grid[g].stage = 0
					}
				}
			}
			this.current.hovering = hovering
			this.current.matches = matches
			if (this.current.matches == this.shape.length) this.can.drop = true
			else return (this.can.drop = false)
		},
		roundRect(ctx, x, y, width, height, radius = 4) {
			ctx.beginPath()
			ctx.moveTo(x + radius, y)
			ctx.lineTo(x + width - radius, y)
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius)
			ctx.lineTo(x + width, y + height - radius)
			ctx.quadraticCurveTo(
				x + width,
				y + height,
				x + width - radius,
				y + height
			)
			ctx.lineTo(x + radius, y + height)
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius)
			ctx.lineTo(x, y + radius)
			ctx.quadraticCurveTo(x, y, x + radius, y)
			ctx.closePath()
			return ctx
		},
		loop() {
			this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
			this.updateGrid()
			if (this.initialized) {
				this.checkShapePosition()
				this.shapeUpdate()
				this.checkPoints()
			}
			if (this.autoplay) window.requestAnimationFrame(this.loop)
		},
		pauseLoop(timeout) {
			window.cancelAnimationFrame(this.animFrame)
			this.timeout = setTimeout(() => {
				this.animFrame = window.requestAnimationFrame(this.loop)
			}, timeout)
		},
		restartGame() {
			this.$store.dispatch('ui/setMenuActive', false)
			this.initialized = false
			this.init()
			this.intro()
		},
		controls() {
			return
		},
	},
}
